var noop = function () { return undefined; };
export { noop };
